export enum HomeImageType {
    MainBanner,
    Banner,
    Feature,
}

export enum BannerType {
    Default,
    Custom,
  }
  